import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=1d3b71a5&scoped=true&"
import script from "./upload.vue?vue&type=script&lang=js&"
export * from "./upload.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/upload.less?vue&type=style&index=0&id=1d3b71a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3b71a5",
  null
  
)

component.options.__file = "upload.vue"
export default component.exports